// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"612":"pptAddinEditor","716":"canvasV10","842":"pptAddinTaskpane","978":"pptAddingCheckout"}[chunkId] || chunkId) + "." + {"347":"bb53f17ef9bda1581994","612":"55fcd71b90c5283ca559","716":"74335b6f11ee768cb521","842":"f9bc3168cfb957adf948","978":"7a54be5bc1751884d143"}[chunkId] + ".js";
};